import React from 'react';
import Layout from '../../components/Layout/Layout';
import OfferPromo from '../../components/Offer/OfferPromo';

const propTypes = {};
const defaultProps = {};

const OfferPromoPage = ({ match }) => {
  const offerId = parseInt(match.params.id, 10);

  return (
    <Layout formattedTitle="offer.promo.breadcrumb">
      <Layout.Col>{!isNaN(offerId) && <OfferPromo offerId={offerId} />}</Layout.Col>
    </Layout>
  );
};

OfferPromo.propTypes = propTypes;
OfferPromo.defaultProps = defaultProps;

export default OfferPromoPage;
